<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <c-card title="Crear tipo de publicación">
          <tipo-publicacion-form />
        </c-card>
      </div>
    </div>
  </div>
</template>
<script>
import TipoPublicacionForm from "@/components/Forms/TipoPublicacionForm.vue";
import CCard from "@/components/CCard.vue";
export default {
  components: {
    TipoPublicacionForm,
    CCard,
  },
};
</script>
